<template>
  <div class="app-content">
    <transition name="el-fade-in-linear">
      <div v-show="promptShow" class="back">
        <div v-show="promptShow" class="copyLink">
          <h1>提示</h1>
          <p>{{ promptContent }}</p>
          <button v-if="promptValue === 'copy'" @click="copyLink">复 制</button>
          <button v-else @click="promptShow = false">确 定</button>
        </div>
      </div>
    </transition>
    <div class="center" @click="download" />
    <div v-if="dialog" class="zhezhao">
      <img src="../../assets/images/zhezhao.png" alt="">
    </div>
  </div>
</template>

<script>
import store from '@/store'

export default {
  name: 'MedicalDownload',
  data() {
    return {
      promptShow: false,
      promptValue: '',
      promptContent: '',
      timer: null,
      dialog: false
    }
  },
  created() {
    store.dispatch('settings/setTitle', '圣云医教云平台')
    const ua = navigator.userAgent.toLowerCase()
    if (ua.match(/MicroMessenger/i) === 'micromessenger') {
      this.dialog = true
      return
    }
    this.closeWeb()
  },
  methods: {
    ejectPrompt(val, content) {
      if (val === 'copy') {
        this.promptContent = '请复制链接地址，去外部浏览器中打开'
        this.promptShow = true
        this.promptValue = val
        return
      }
      this.promptContent = content
      this.promptShow = true
      this.promptValue = val
    },
    copyLink() {
      const copyInput = document.createElement('input')
      copyInput.value = 'https://www.syyxcloud.com/#/download'
      document.body.appendChild(copyInput)
      copyInput.select()
      document.execCommand('Copy')
      document.body.removeChild(copyInput)
      this.$message.success('复制成功')
      this.promptShow = false
    },
    download() {
      const ua = navigator.userAgent.toLowerCase()
      if (ua.match(/MicroMessenger/i) === 'micromessenger') {
        this.ejectPrompt('copy')
        return
      }
      if (this.judgeClient() === 'Android') {
        window.location.href = this.getPhoneType()
        return
      }
      if (this.judgeClient() === 'IOS') {
        window.location.href = 'https://testflight.apple.com/join/HamhCHv4'
        // window.location.href = 'https://apps.apple.com/us/app/临床训练营/id6449174548'
      }
    },
    getPhoneType() {
      const userAgent = navigator.userAgent
      let href = 'https://www.pgyer.com/yixuecheng'
      // let href = 'https://sj.qq.com/appdetail/com.yddmi.yddclinic'
      // if (/iPhone|iPad/i.test(userAgent)) {
      //   href = 'https://apps.apple.com/us/app/临床训练营/id6449174548'
      // } else if (/HUAWEI/i.test(userAgent)) {
      //   href = 'appmarket://details?id=com.yddmi.yddclinic'
      // } else if (/honor/i.test(userAgent)) {
      //   href = 'appmarket://details?id=com.yddmi.yddclinic'
      // } else if (/Xiaomi/i.test(userAgent)) {
      //   href = 'mimarket://details?id=com.yddmi.yddclinic'
      // } else if (/SamSung/i.test(userAgent)) {
      //   href = 'samsungapps://ProductDetail/com.yddmi.yddclinic'
      // } else if (/vivo/i.test(userAgent)) {
      //   href = 'vivomarket://details?id=com.yddmi.yddclinic'
      // } else if (/HeyTapBrowser/i.test(userAgent)) {
      //   href = 'oppomarket://details?packagename=com.yddmi.yddclinic'
      // }
      return href
    },
    closeWeb() {
      if (this.judgeClient() === 'Android') {
        this.closeWebAndroid()
        return
      }
      if (this.judgeClient() === 'IOS') {
        this.closeWebIOS()
      }
    },
    closeWebAndroid() {
      window.location.href = 'openapp://syyxcloud.com'
    },
    closeWebIOS() {
      window.location.href = 'ydd9527://'
    },
    judgeClient() {
      const u = navigator.userAgent
      const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1
      const isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
      if (isAndroid) {
        return 'Android'
      }
      if (isIOS) {
        return 'IOS'
      }
      return 'PC'
    }
  }
}
</script>

<style lang="scss" scoped>
.app-content {
  width: 100%;
  height: 100%;
  position: relative;
  text-align: center;

  .back {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 14, 14, 0.5);
    z-index: 9;
    display: flex;
    align-items: center;
    justify-content: center;
    backdrop-filter: blur(.0267rem);

    .copyLink {
      width: 80%;
      background-color: #fff;
      border-radius: .16rem;

      h1 {
        font-size: .8rem;
        font-weight: 500;
        margin-top: 5%;
        color: #545454;
        padding: 0 5%;
        text-align: center;
      }

      p {
        font-size: .6933rem;
        margin-top: 5%;
        color: #b2b2b2;
        padding: 0 5%;
        text-align: center;
      }

      button {
        width: 100%;
        height: 15%;
        margin-top: 8%;
        border: 0;
        border-top: 1px solid #efefef;
        background-color: #fff;
        font-size: .7467rem;
        font-weight: 600;
        color: #4ec39f;
        border-radius: 0 0 6px 6px;
        padding: 8px 0;
      }
    }
  }

  .center {
    width: 10rem;
    height: 20.48rem;
    background: url('https://file.medmeta.com/web/images/activityDowniod.png') no-repeat;
    background-size: 100% 100%;
  }

  .zhezhao {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;

    img {
      width: 10rem;
      height: 20.48rem;
    }
  }
}
</style>
